module.exports = __webpack_public_path__ + "img/zhifubaoIcon.7c130845.jpg";